export default __webpack_public_path__ + "media/mood-og-background.323786c080eb583b37dec3e7babbfc67.png";